const countries = {
  Afeganistão: "AF",
  "África do Sul": "ZA",
  Albânia: "AL",
  Alemanha: "DE",
  Andorra: "AD",
  Angola: "AO",
  Anguila: "AI",
  Antártida: "AQ",
  "Antígua e Barbuda": "AG",
  "Arábia Saudita": "SA",
  Argélia: "DZ",
  Argentina: "AR",
  Armênia: "AM",
  Aruba: "AW",
  Austrália: "AU",
  Áustria: "AT",
  Azerbaijão: "AZ",
  Bahamas: "BS",
  Bangladesh: "BD",
  Barbados: "BB",
  Bahrein: "BH",
  Bélgica: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermudas: "BM",
  Bielorrússia: "BY",
  Bolívia: "BO",
  "Bósnia e Herzegovina": "BA",
  Botsuana: "BW",
  Brasil: "BR",
  Brunei: "BN",
  Bulgária: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Butão: "BT",
  "Cabo Verde": "CV",
  Camarões: "CM",
  Camboja: "KH",
  Canadá: "CA",
  Catar: "QA",
  Cazaquistão: "KZ",
  Chade: "TD",
  Chile: "CL",
  China: "CN",
  Chipre: "CY",
  Colômbia: "CO",
  Comores: "KM",
  "Congo-Brazzaville": "CG",
  "Congo-Kinshasa": "CD",
  "Coreia do Norte": "KP",
  "Coreia do Sul": "KR",
  "Costa do Marfim": "CI",
  "Costa Rica": "CR",
  Croácia: "HR",
  Cuba: "CU",
  Dinamarca: "DK",
  Djibuti: "DJ",
  Dominica: "DM",
  Egito: "EG",
  "El Salvador": "SV",
  "Emirados Árabes Unidos": "AE",
  Equador: "EC",
  Eritreia: "ER",
  Eslováquia: "SK",
  Eslovênia: "SI",
  Espanha: "ES",
  "Estados Unidos": "US",
  Estônia: "EE",
  Eswatini: "SZ",
  Etiópia: "ET",
  Fiji: "FJ",
  Filipinas: "PH",
  Finlândia: "FI",
  França: "FR",
  Gabão: "GA",
  Gâmbia: "GM",
  Gana: "GH",
  Geórgia: "GE",
  Gibraltar: "GI",
  Granada: "GD",
  Grécia: "GR",
  Groenlândia: "GL",
  Guadalupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guiana: "GY",
  "Guiana Francesa": "GF",
  Guiné: "GN",
  "Guiné-Bissau": "GW",
  "Guiné Equatorial": "GQ",
  Haiti: "HT",
  Holanda: "NL",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hungria: "HU",
  Iémen: "YE",
  "Ilha Bouvet": "BV",
  "Ilha do Natal": "CX",
  "Ilha Norfolk": "NF",
  "Ilhas Caimão": "KY",
  "Ilhas Cocos": "CC",
  "Ilhas Cook": "CK",
  "Ilhas Feroé": "FO",
  "Ilhas Geórgia do Sul e Sandwich do Sul": "GS",
  "Ilhas Malvinas": "FK",
  "Ilhas Marianas do Norte": "MP",
  "Ilhas Marshall": "MH",
  "Ilhas Pitcairn": "PN",
  "Ilhas Salomão": "SB",
  "Ilhas Turcas e Caicos": "TC",
  "Ilhas Virgens Americanas": "VI",
  "Ilhas Virgens Britânicas": "VG",
  Índia: "IN",
  Indonésia: "ID",
  Irã: "IR",
  Iraque: "IQ",
  Irlanda: "IE",
  Islândia: "IS",
  Israel: "IL",
  Itália: "IT",
  Jamaica: "JM",
  Japão: "JP",
  Jersey: "JE",
  Jordânia: "JO",
  Kosovo: "XK",
  Kuwait: "KW",
  Laos: "LA",
  Lesoto: "LS",
  Letônia: "LV",
  Líbano: "LB",
  Libéria: "LR",
  Líbia: "LY",
  Liechtenstein: "LI",
  Lituânia: "LT",
  Luxemburgo: "LU",
  Macau: "MO",
  "Macedônia do Norte": "MK",
  Madagáscar: "MG",
  Malásia: "MY",
  Malawi: "MW",
  Maldivas: "MV",
  Mali: "ML",
  Malta: "MT",
  Marrocos: "MA",
  Martinica: "MQ",
  Maurício: "MU",
  Mauritânia: "MR",
  Mayotte: "YT",
  México: "MX",
  Mianmar: "MM",
  Micronésia: "FM",
  Moçambique: "MZ",
  Moldávia: "MD",
  Mônaco: "MC",
  Mongólia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Namíbia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Nicarágua: "NI",
  Níger: "NE",
  Nigéria: "NG",
  Niue: "NU",
  Noruega: "NO",
  "Nova Caledônia": "NC",
  "Nova Zelândia": "NZ",
  Omã: "OM",
  "Países Baixos": "NL",
  Palau: "PW",
  Palestina: "PS",
  Panamá: "PA",
  "Papua-Nova Guiné": "PG",
  Paquistão: "PK",
  Paraguai: "PY",
  Peru: "PE",
  "Polinésia Francesa": "PF",
  Polônia: "PL",
  "Porto Rico": "PR",
  Portugal: "PT",
  Quênia: "KE",
  Quirguistão: "KG",
  Quiribáti: "KI",
  "Reino Unido": "GB",
  "República Centro-Africana": "CF",
  "República Checa": "CZ",
  "República Dominicana": "DO",
  Romênia: "RO",
  Ruanda: "RW",
  Rússia: "RU",
  "Saara Ocidental": "EH",
  "Saint Kitts e Nevis": "KN",
  "Saint Pierre e Miquelon": "PM",
  "Saint Vincent e Granadinas": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Santa Helena": "SH",
  "Santa Lúcia": "LC",
  "São Bartolomeu": "BL",
  "São Martinho": "MF",
  "São Tomé e Príncipe": "ST",
  Senegal: "SN",
  "Serra Leoa": "SL",
  Sérvia: "RS",
  Seicheles: "SC",
  Singapura: "SG",
  Síria: "SY",
  Somália: "SO",
  "Sri Lanka": "LK",
  Suazilândia: "SZ",
  Sudão: "SD",
  "Sudão do Sul": "SS",
  Suécia: "SE",
  Suíça: "CH",
  Suriname: "SR",
  Tailândia: "TH",
  Taiwan: "TW",
  Tajiquistão: "TJ",
  Tanzânia: "TZ",
  "Timor-Leste": "TL",
  Togo: "TG",
  Tonga: "TO",
  "Trinidad e Tobago": "TT",
  Tunísia: "TN",
  Turcomenistão: "TM",
  Turquia: "TR",
  Tuvalu: "TV",
  Ucrânia: "UA",
  Uganda: "UG",
  Uruguai: "UY",
  Uzbequistão: "UZ",
  Vanuatu: "VU",
  Vaticano: "VA",
  Venezuela: "VE",
  Vietnã: "VN",
  Zâmbia: "ZM",
  Zimbábue: "ZW",
};

export { countries };
